import React from "react";
import {
  LightningCharge,
  People,
  Award,
  GraphUpArrow,
  Clock,
  ShieldCheck,
} from "react-bootstrap-icons";

const items = [
  {
    title: "Framework-Led Delivery",
    text: "Structured methodology ensures consistent, predictable results every time.",
    icon: <LightningCharge />,
  },
  {
    title: "Expert Team",
    text: "Certified consultants with decades of combined experience in workforce management.",
    icon: <People />,
  },
  {
    title: "Proven Track Record",
    text: "200+ projects delivered across industries with 99% client satisfaction.",
    icon: <Award />,
  },
  {
    title: "Business-Driven Outcomes",
    text: "Focus on measurable business value, not just technical delivery.",
    icon: <GraphUpArrow />,
  },
  {
    title: "Rapid Deployment",
    text: "Streamlined processes ensure faster implementation while maintaining quality.",
    icon: <Clock />,
  },
  {
    title: "Long-Term Partnership",
    text: "Ongoing support and strategic guidance that extends well beyond go-live.",
    icon: <ShieldCheck />,
  },
];

export default function WhyChoose5Helms() {
  return (
    <section className="py-5" id="why-us">
      <div className="container text-center">
        <small className="text-uppercase text-primary fw-semibold">
          Why Choose 5 Helms Consulting
        </small>

        <h2 className="fw-bold my-3">
          Your Trusted Implementation Partner
        </h2>

        <p className="text-muted mb-5">
          We combine deep technical expertise with a client-first approach to
          deliver exceptional workforce management solutions.
        </p>

        <div className="row g-4">
          {items.map((item, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className="why-card h-100 text-start">
                <div className="icon-wrapper mb-3"  >
                  {item.icon}
                </div>
                <h5 className="fw-bold">{item.title}</h5>
                <p className="text-muted mb-0">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
